import * as GraphqlImporter from './graphql-importer'
import commonRequestApi from '../../request'
import Response from '../../Response'
import { DocumentNode } from 'graphql'

export const SERVER_URL = '/web/gql/KnowledgePreexam-default'

// 枚举

// 类

export class Page {
  pageNo?: number
  pageSize?: number
}

/**
 * 知识点绑定信息
@author wujf
@since 2020/10/22
 */
export class KnowledgeBindRequest {
  /**
   * 所属考纲元素编号，必填
   */
  syllabusMataId?: string
  /**
   * 绑定的知识点所属标签编号，必填
   */
  knowledgeMataId?: string
  /**
   * 考纲元素排序，如果不填内部自动生成
   */
  sort?: number
  /**
   * 考纲元素权重，不填默认0
   */
  weights?: number
  /**
   * 重要度，不填默认0
   */
  importance?: number
}

/**
 * 知识点创建信息
@author wujf
@since 2020/10/22
 */
export class KnowledgeCreateRequest {
  /**
   * 所属考纲元素编号，必填
   */
  syllabusMataId?: string
  /**
   * 知识点名称，必填
   */
  knowledgeName?: string
  /**
   * 考纲元素排序，如果不填内部自动生成
   */
  sort?: number
  /**
   * 考纲元素权重，不填默认0
   */
  weights?: number
  /**
   * 重要度，不填默认0
   */
  importance?: number
}

/**
 * 考纲元素更新信息
@author wujf
@since 2020/10/22
 */
export class KnowledgeUpdateRequest {
  /**
   * 知识点编号，必填
   */
  knowledgeId?: string
  /**
   * 所属考纲元素编号，不填表示不更新
   */
  syllabusMataId?: string
  /**
   * 知识点名称，不填表示不更新
<p>
更新知识点名称，实际上更新的是对应知识点标签的名称，即绑定同一个知识点标签的知识点名称会同步更新
   */
  name?: string
  /**
   * 知识点排序，不填表示不更新
   */
  sort?: number
  /**
   * 知识点权重，不填表示不更新
   */
  weights?: number
  /**
   * 重要度，不填默认0
   */
  importance?: number
}

/**
 * 考纲创建信息
@author wujf
@since 2020/10/21
 */
export class SyllabusCreateRequest {
  /**
   * 所属专业编号
   */
  majorId?: string
  /**
   * 考纲名称
   */
  name?: string
  /**
   * 考纲权重层级，如果为null，则不设置
@see com.fjhb.platform.core.v1.knowledge.api.dto.constants.WeightsLevel
   */
  weightsLevel?: number
  /**
   * 发布年度,年度标签编号列表
   */
  yearIdList?: Array<string>
  /**
   * 适用地区，地区标签编号列表
   */
  regionIdList?: Array<string>
}

/**
 * 考纲元素创建信息
@author wujf
@since 2020/10/22
 */
export class SyllabusMataCreateRequest {
  /**
   * 所属考纲编号，必填
   */
  syllabusId?: string
  /**
   * 上级考纲元素编号，不填默认根节点
   */
  parentId?: string
  /**
   * 考纲元素名称，必填
   */
  name?: string
  /**
   * 考纲元素排序，如果不填内部自动生成
   */
  sort?: number
  /**
   * 考纲元素权重，不填默认0
   */
  weights?: number
  /**
   * 重要度，不填默认0
   */
  importance?: number
}

/**
 * 考纲元素更新信息
@author wujf
@since 2020/10/22
 */
export class SyllabusMataUpdateRequest {
  /**
   * 考纲元素编号，必填
   */
  syllabusMataId?: string
  /**
   * 上级考纲元素编号，不填表示不更新
   */
  parentId?: string
  /**
   * 考纲元素名称，不填表示不更新
   */
  name?: string
  /**
   * 考纲元素排序，不填表示不更新
   */
  sort?: number
  /**
   * 考纲元素权重，不填表示不更新
   */
  weights?: number
  /**
   * 重要度，不填默认0
   */
  importance?: number
}

/**
 * 考纲信息查询
@author wujf
@since 2020/11/17
 */
export class SyllabusQueryRequest {
  /**
   * 专业编号
   */
  majorIdList?: Array<string>
  /**
   * 考纲编号列表
   */
  syllabusIdList?: Array<string>
  /**
   * 年度标签编号列表
   */
  yearIdList?: Array<string>
  /**
   * 地区标签编号列表
   */
  regionIdList?: Array<string>
}

/**
 * 考纲创建信息
@author wujf
@since 2020/11/21
 */
export class SyllabusUpdateRequest {
  /**
   * 考纲编号
   */
  syllabusId?: string
  /**
   * 考纲名称，为null表示不更新
   */
  name?: string
  /**
   * 考纲权重层级，如果为null，则不更新
@see com.fjhb.platform.core.v1.knowledge.api.dto.constants.WeightsLevel
   */
  weightsLevel?: number
  /**
   * 发布年度,年度标签编号列表，为null表示不更新
   */
  yearIdList?: Array<string>
  /**
   * 适用地区，地区标签编号列表，为null表示不更新
   */
  regionIdList?: Array<string>
}

/**
 * 转换为知识点信息
@author wujf
@since 2020/11/12
 */
export class TransformToKnowledgeRequest {
  /**
   * 原始知识点编号，必填
   */
  originalSyllabusMataId?: string
  /**
   * 重命名新的知识点名称，不填表示不更新
   */
  name?: string
  /**
   * 新的知识点排序，不填表示不更新
   */
  sort?: number
  /**
   * 新的知识点权重，不填表示不更新
   */
  weights?: number
  /**
   * 新的知识点重要度，不填表示不更新
   */
  importance?: number
}

/**
 * 转换为考纲元素信息
@author wujf
@since 2020/11/12
 */
export class TransformToSyllabusMataRequest {
  /**
   * 原始知识点编号，必填
   */
  originalKnowledgeId?: string
  /**
   * 重命名新的考纲元素名称，不填表示不更新
   */
  name?: string
  /**
   * 新的考纲元素排序，不填表示不更新
   */
  sort?: number
  /**
   * 新的考纲元素权重，不填表示不更新
   */
  weights?: number
  /**
   * 新的考纲元素重要度，不填表示不更新
   */
  importance?: number
}

/**
 * 考纲元素子考纲元素信息
@author wujf
@since 2020/10/23
 */
export class ChildrenMataResponse {
  /**
   * 子节点编号
<pre>
type&#x3D;0,表示考纲元素编号
type&#x3D;1,表示知识点编号
</pre>
@see #type
   */
  nodeId: string
  /**
   * 子节点类型，0-考纲元素，1-知识点
   */
  type: number
}

/**
 * 维度属性信息
@author wujf
@since 2020/10/23
 */
export class DimensionPropertyResponse {
  /**
   * 属性编号
   */
  propertyId: string
  /**
   * 属性名称
   */
  propertyName: string
}

/**
 * 行业信息
@author wujf
@since 2020/4/20
 */
export class IndustryResponse {
  /**
   * 行业编号
   */
  id: string
  /**
   * 名称
   */
  name: string
  /**
   * 代码
   */
  code: string
  /**
   * 是否可用
   */
  enabled: boolean
  /**
   * 所属关系节点编号
   */
  relationId: string
  /**
   * 专业列表
   */
  majorModelList: Array<MajorResponse>
}

/**
 * 知识点信息
@author wujf
@since 2020/10/23
 */
export class KnowledgeResponse {
  /**
   * 知识点编号
   */
  id: string
  /**
   * 平台编号
   */
  platformId: string
  /**
   * 平台版本编号
   */
  platformVersionId: string
  /**
   * 项目编号
   */
  projectId: string
  /**
   * 子项目编号
   */
  subProjectId: string
  /**
   * 组织机构编号
   */
  organizationId: string
  /**
   * 单位编号
   */
  unitId: string
  /**
   * 知识点元素编号
   */
  knowledgeMataId: string
  /**
   * 知识点名称
   */
  name: string
  /**
   * 所属考纲元素编号
   */
  syllabusMataId: string
  /**
   * 知识点排序|同级知识点序号
   */
  sort: number
  /**
   * 知识点权重
   */
  weights: number
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 创建人编号
   */
  createUserId: string
  /**
   * 重要度
   */
  importance: number
}

/**
 * 专业信息
@author wujf
@since 2020/10/23
 */
export class MajorInfoResponse {
  /**
   * 编号
   */
  id: string
  /**
   * 名称
   */
  name: string
}

/**
 * 专业信息
@author wujf
@since 2020/4/20
 */
export class MajorResponse {
  /**
   * 专业编号
   */
  id: string
  /**
   * 名称
   */
  name: string
  /**
   * 代码
   */
  code: string
  /**
   * 是否可用
   */
  enabled: boolean
  /**
   * 当前节点关系编号
   */
  relationId: string
  /**
   * 同一级排序
   */
  sort: number
}

/**
 * 考纲元素信息
@author wujf
@since 2020/10/23
 */
export class SyllabusMataResponse {
  /**
   * 考纲元素编号
   */
  id: string
  /**
   * 平台编号
   */
  platformId: string
  /**
   * 平台版本编号
   */
  platformVersionId: string
  /**
   * 项目编号
   */
  projectId: string
  /**
   * 子项目编号
   */
  subProjectId: string
  /**
   * 组织机构编号
   */
  organizationId: string
  /**
   * 单位编号
   */
  unitId: string
  /**
   * 所属考纲编号
   */
  syllabusId: string
  /**
   * 上级考纲元素编号|0为根节点
   */
  parentId: string
  /**
   * 考纲元素名称
   */
  name: string
  /**
   * 考纲元素排序|同一级序号
   */
  sort: number
  /**
   * 考纲元素权重
   */
  weights: number
  /**
   * 是否启用
   */
  enable: boolean
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 创建人编号
   */
  createUserId: string
  /**
   * 重要度
   */
  importance: number
  /**
   * 考纲元素下一级子元素列表
   */
  childList: Array<ChildrenMataResponse>
  /**
   * 考纲元素路径
   */
  path: string
}

/**
 * 考纲信息
@author wujf
@since 2020/10/23
 */
export class SyllabusResponse {
  /**
   * 考纲编号
   */
  id: string
  /**
   * 所属平台ID
   */
  platformId: string
  /**
   * 所属平台版本ID
   */
  platformVersionId: string
  /**
   * 所属项目ID
   */
  projectId: string
  /**
   * 所属子项目ID
   */
  subProjectId: string
  /**
   * 所属单位ID
   */
  unitId: string
  /**
   * 所属组织机构ID
   */
  organizationId: string
  /**
   * 考纲名称
   */
  name: string
  /**
   * 是否启用
   */
  enable: boolean
  /**
   * 权重层级
@see WeightsLevel
   */
  weightsLevel: number
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 创建人编号
   */
  createUserId: string
  /**
   * 所属专业
   */
  major: MajorInfoResponse
  /**
   * 所属年度
   */
  yearList: Array<DimensionPropertyResponse>
  /**
   * 所属地区
   */
  regionList: Array<DimensionPropertyResponse>
}

export class SyllabusResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<SyllabusResponse>
}

export class SyllabusMataResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<SyllabusMataResponse>
}

class DataGateway {
  async _commonQuery<T>(query: DocumentNode, params?: unknown, operation?: string): Promise<Response<T>> {
    return commonRequestApi<T>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 指定专业下是否存在考纲
   * @param syllabusId 考纲编号
   * @param majorId    专业编号
   * @return true/false,存在/不存在
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async existsSyllabusByMajorId(
    params: { syllabusId?: string; majorId?: string },
    query: DocumentNode = GraphqlImporter.existsSyllabusByMajorId,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取所有行业及专业
   * @return 行业专业关系树
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findAllIndustryRelationList(
    query: DocumentNode = GraphqlImporter.findAllIndustryRelationList,
    operation?: string
  ): Promise<Response<Array<IndustryResponse>>> {
    return commonRequestApi<Array<IndustryResponse>>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 获取系统下所有定义地区列表
   * @return 地区列表
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findAllRegionList(
    query: DocumentNode = GraphqlImporter.findAllRegionList,
    operation?: string
  ): Promise<Response<Array<DimensionPropertyResponse>>> {
    return commonRequestApi<Array<DimensionPropertyResponse>>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 获取系统下所有定义年度列表
   * @return 年度列表
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findAllYearList(
    query: DocumentNode = GraphqlImporter.findAllYearList,
    operation?: string
  ): Promise<Response<Array<DimensionPropertyResponse>>> {
    return commonRequestApi<Array<DimensionPropertyResponse>>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 获取考纲树下指定考纲元素下的子考纲元素列表
   * @param syllabusId     考纲编号
   * @param syllabusMataId 指定考纲元素编号
   * @return 考纲元素聚合根
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findChildSyllabusMataList(
    params: { syllabusId?: string; syllabusMataId?: string },
    query: DocumentNode = GraphqlImporter.findChildSyllabusMataList,
    operation?: string
  ): Promise<Response<Array<SyllabusMataResponse>>> {
    return commonRequestApi<Array<SyllabusMataResponse>>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 查询指定知识点信息
   * @param knowledgeId 知识点编号
   * @return 知识点聚合根
   * @param query 查询 graphql 语法文档
   * @param knowledgeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findKnowledge(
    knowledgeId: string,
    query: DocumentNode = GraphqlImporter.findKnowledge,
    operation?: string
  ): Promise<Response<KnowledgeResponse>> {
    return commonRequestApi<KnowledgeResponse>(SERVER_URL, {
      query: query,
      variables: { knowledgeId },
      operation: operation
    })
  }

  /**   * 获取考纲树下根节点考纲元素列表
   * @param syllabusId 考纲编号
   * @return 考纲元素聚合根
   * @param query 查询 graphql 语法文档
   * @param syllabusId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findRootSyllabusMataList(
    syllabusId: string,
    query: DocumentNode = GraphqlImporter.findRootSyllabusMataList,
    operation?: string
  ): Promise<Response<Array<SyllabusMataResponse>>> {
    return commonRequestApi<Array<SyllabusMataResponse>>(SERVER_URL, {
      query: query,
      variables: { syllabusId },
      operation: operation
    })
  }

  /**   * 获取考纲信息
   * @param syllabusId 考纲编号
   * @return 考纲集合根
   * @param query 查询 graphql 语法文档
   * @param syllabusId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findSyllabus(
    syllabusId: string,
    query: DocumentNode = GraphqlImporter.findSyllabus,
    operation?: string
  ): Promise<Response<SyllabusResponse>> {
    return commonRequestApi<SyllabusResponse>(SERVER_URL, {
      query: query,
      variables: { syllabusId },
      operation: operation
    })
  }

  /**   * 查询指定考纲元素信息
   * @param syllabusMataId 考纲元素编号
   * @return 考纲元素聚合根
   * @param query 查询 graphql 语法文档
   * @param syllabusMataId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findSyllabusMata(
    syllabusMataId: string,
    query: DocumentNode = GraphqlImporter.findSyllabusMata,
    operation?: string
  ): Promise<Response<SyllabusMataResponse>> {
    return commonRequestApi<SyllabusMataResponse>(SERVER_URL, {
      query: query,
      variables: { syllabusMataId },
      operation: operation
    })
  }

  /**   * 查询指定考纲元素信息列表
   * @param syllabusMataIdList 考纲元素编号列表
   * @return 考纲元素聚合根列表
   * @param query 查询 graphql 语法文档
   * @param syllabusMataIdList 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findSyllabusMataList(
    syllabusMataIdList: Array<string>,
    query: DocumentNode = GraphqlImporter.findSyllabusMataList,
    operation?: string
  ): Promise<Response<Array<SyllabusMataResponse>>> {
    return commonRequestApi<Array<SyllabusMataResponse>>(SERVER_URL, {
      query: query,
      variables: { syllabusMataIdList },
      operation: operation
    })
  }

  /**   * 依据条件获取考纲信息
   * @param query    查询条件，可为空
   * @param pageSize 每页条数
   * @param pageNo   页码
   * @return 考纲信息
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findSyllabusPageListByQuery(
    params: { query?: SyllabusQueryRequest; pageSize: number; pageNo: number },
    query: DocumentNode = GraphqlImporter.findSyllabusPageListByQuery,
    operation?: string
  ): Promise<Response<SyllabusResponsePage>> {
    return commonRequestApi<SyllabusResponsePage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 查询指定考纲下指定权重层级下总权重值
   * @param syllabusId 考纲编号
   * @return 总权重值
   * @param query 查询 graphql 语法文档
   * @param syllabusId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findSyllabusTotalWeights(
    syllabusId: string,
    query: DocumentNode = GraphqlImporter.findSyllabusTotalWeights,
    operation?: string
  ): Promise<Response<number>> {
    return commonRequestApi<number>(SERVER_URL, {
      query: query,
      variables: { syllabusId },
      operation: operation
    })
  }

  /**   * 获取考纲集合
   * @param syllabusIdList 考纲编号列表
   * @return 考纲集合
   * @param query 查询 graphql 语法文档
   * @param syllabusIdList 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async listSyllabus(
    syllabusIdList: Array<string>,
    query: DocumentNode = GraphqlImporter.listSyllabus,
    operation?: string
  ): Promise<Response<Array<SyllabusResponse>>> {
    return commonRequestApi<Array<SyllabusResponse>>(SERVER_URL, {
      query: query,
      variables: { syllabusIdList },
      operation: operation
    })
  }

  /**   * 根据考纲id分页查询考纲元素
   * @param page       分页信息
   * @param syllabusId 考纲编号
   * @return 考纲元素信息列表
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async pageMataBySyllabus(
    params: { page?: Page; syllabusId?: string },
    query: DocumentNode = GraphqlImporter.pageMataBySyllabus,
    operation?: string
  ): Promise<Response<SyllabusMataResponsePage>> {
    return commonRequestApi<SyllabusMataResponsePage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 新增考纲所属地区
   * @param syllabusId 考纲编号
   * @param regionList 所属地区列表
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async addSyllabusRegion(
    params: { syllabusId?: string; regionList?: Array<string> },
    mutate: DocumentNode = GraphqlImporter.addSyllabusRegion,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 新增考纲所属年度
   * @param syllabusId 考纲编号
   * @param yearList   所属年度列表
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async addSyllabusYear(
    params: { syllabusId?: string; yearList?: Array<string> },
    mutate: DocumentNode = GraphqlImporter.addSyllabusYear,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 绑定一个已存在的知识点标签作为知识点
   * @param bindInfo 知识点绑定信息
   * @param mutate 查询 graphql 语法文档
   * @param bindInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async bindKnowledge(
    bindInfo: KnowledgeBindRequest,
    mutate: DocumentNode = GraphqlImporter.bindKnowledge,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { bindInfo },
      operation: operation
    })
  }

  /**   * 创建一个新的知识点标签作为知识点
   * @param createInfo 知识点创建信息
   * @param mutate 查询 graphql 语法文档
   * @param createInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createKnowledge(
    createInfo: KnowledgeCreateRequest,
    mutate: DocumentNode = GraphqlImporter.createKnowledge,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { createInfo },
      operation: operation
    })
  }

  /**   * 创建考纲
   * @param createInfo 考纲信息
   * @param mutate 查询 graphql 语法文档
   * @param createInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createSyllabus(
    createInfo: SyllabusCreateRequest,
    mutate: DocumentNode = GraphqlImporter.createSyllabus,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { createInfo },
      operation: operation
    })
  }

  /**   * 创建考纲元素
   * @param createInfo 考纲元素创建信息
   * @param mutate 查询 graphql 语法文档
   * @param createInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createSyllabusMata(
    createInfo: SyllabusMataCreateRequest,
    mutate: DocumentNode = GraphqlImporter.createSyllabusMata,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { createInfo },
      operation: operation
    })
  }

  /**   * 删除指定的知识点
   * @param knowledgeId 知识点编号
   * @param mutate 查询 graphql 语法文档
   * @param knowledgeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async deleteKnowledge(
    knowledgeId: string,
    mutate: DocumentNode = GraphqlImporter.deleteKnowledge,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { knowledgeId },
      operation: operation
    })
  }

  /**   * 删除考纲，验证考纲下是否存在资源，同时删除考纲下的考纲元素及知识点
   * @param syllabusId 考纲编号
   * @param mutate 查询 graphql 语法文档
   * @param syllabusId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async deleteSyllabus(
    syllabusId: string,
    mutate: DocumentNode = GraphqlImporter.deleteSyllabus,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { syllabusId },
      operation: operation
    })
  }

  /**   * 删除考纲元素，验证考纲元素下是否存在资源
   * @param syllabusMataId 考纲元素编号
   * @param mutate 查询 graphql 语法文档
   * @param syllabusMataId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async deleteSyllabusMata(
    syllabusMataId: string,
    mutate: DocumentNode = GraphqlImporter.deleteSyllabusMata,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { syllabusMataId },
      operation: operation
    })
  }

  /**   * 验证指定专业下是否存在指定考纲名称的考纲
   * @param majorId 专业编号
   * @param name    考纲名称
   * @return true/false,存在/不存在
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async existsSyllabusByMajor(
    params: { majorId?: string; name?: string },
    mutate: DocumentNode = GraphqlImporter.existsSyllabusByMajor,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 验证指定考纲是否配置的权重层级，同时配置了权重
   * @param syllabusId 考纲编号
   * @return true/false,存在/不存在
   * @param mutate 查询 graphql 语法文档
   * @param syllabusId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async existsSyllabusWithWeightLevelAndWeights(
    syllabusId: string,
    mutate: DocumentNode = GraphqlImporter.existsSyllabusWithWeightLevelAndWeights,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: mutate,
      variables: { syllabusId },
      operation: operation
    })
  }

  /**   * 移动考纲资源
   * @param originalId 原始考纲元素编号或知识点编号
   * @param targetId   目标纲元素编号或知识点编号
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async moveResource(
    params: { originalId?: string; targetId?: string },
    mutate: DocumentNode = GraphqlImporter.moveResource,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 将考纲元素转换为知识点
   * @param transformInfo 转换信息
   * @param mutate 查询 graphql 语法文档
   * @param transformInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async transformToKnowledge(
    transformInfo: TransformToKnowledgeRequest,
    mutate: DocumentNode = GraphqlImporter.transformToKnowledge,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { transformInfo },
      operation: operation
    })
  }

  /**   * 将知识点转换为考纲元素
   * @param transformInfo 转换信息
   * @param mutate 查询 graphql 语法文档
   * @param transformInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async transformToSyllabusMata(
    transformInfo: TransformToSyllabusMataRequest,
    mutate: DocumentNode = GraphqlImporter.transformToSyllabusMata,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { transformInfo },
      operation: operation
    })
  }

  /**   * 更新知识点名称，实际上更新的是对应知识点标签的名称，即绑定同一个知识点标签的知识点名称会同步更新
   * @param updateInfo 知识点更新信息
   * @param mutate 查询 graphql 语法文档
   * @param updateInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateKnowledge(
    updateInfo: KnowledgeUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateKnowledge,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { updateInfo },
      operation: operation
    })
  }

  /**   * 更新考纲
   * @param updateInfo 更新信息
   * @param mutate 查询 graphql 语法文档
   * @param updateInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateSyllabus(
    updateInfo: SyllabusUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateSyllabus,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { updateInfo },
      operation: operation
    })
  }

  /**   * 更新考纲元素编号
   * @param updateInfo 考纲元素更新信息
   * @param mutate 查询 graphql 语法文档
   * @param updateInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateSyllabusMata(
    updateInfo: SyllabusMataUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateSyllabusMata,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { updateInfo },
      operation: operation
    })
  }

  /**   * 修改考纲名称，同一个专业下不能重复
   * @param syllabusId 考纲编号
   * @param name       考纲名称
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateSyllabusName(
    params: { syllabusId?: string; name?: string },
    mutate: DocumentNode = GraphqlImporter.updateSyllabusName,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }
}

export default new DataGateway()
